
import {Component, Prop, Vue} from "vue-property-decorator";

/**
 * Raporlar bölümünün sayfa başlığı: gradyan ikon karesi + başlık + rozet + alt başlık.
 * Renkler tema değişkenlerinden gelir; ürün teması (mavi/mor/turuncu) değişince
 * başlık da onunla birlikte değişir.
 */
@Component({})
export default class RaporSayfaBasligi extends Vue {
  @Prop({default: "Raporlar"}) baslik!: string;
  @Prop({default: ""}) rozet!: string;
  @Prop({default: ""}) altBaslik!: string;
  @Prop({default: "mdi-file-chart-outline"}) ikon!: string;
}
